// Generated by tools/sync-heroes.mjs. Do not edit.
import type { HeroDirectoryEntry } from "./directory-types";
export { games } from "../games";
export const heroDirectory: HeroDirectoryEntry[] = [
  {
    "id": "6711",
    "gameId": "arcanatactics",
    "name": "롱기누스",
    "subtitle": "",
    "latin": "",
    "head": "https://wiki-obs.obs.cn-north-1.myhuaweicloud.com/wiki/arcanatactics/catalog/images/90543bbc99e9d6aa4d9d876f9272ac9acfe053d7c4ebd5e9a69cb6faa94bb52c.png",
    "facets": {
      "attribute": "光辉",
      "category": "枪使",
      "role": "攻击",
      "stars": "6"
    },
    "updatedAt": "2026-09-03",
    "traitIcons": [
      {
        "label": "职业：枪使",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chainfo_0007.png"
      },
      {
        "label": "属性：光辉",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0004.png"
      },
      {
        "label": "定位：攻击",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0008.png"
      }
    ]
  },
  {
    "id": "3101",
    "gameId": "arcanatactics",
    "name": "符文骑士",
    "subtitle": "",
    "latin": "",
    "head": "https://wiki-obs.obs.cn-north-1.myhuaweicloud.com/wiki/arcanatactics/catalog/images/9ef7ab36b210bd5ddd34a785249ef9284383a89c9a2d43190d220a8bbf906b6a.png",
    "facets": {
      "attribute": "火焰",
      "category": "剑士",
      "role": "攻击",
      "stars": "3"
    },
    "updatedAt": "2026-09-03",
    "traitIcons": [
      {
        "label": "职业：剑士",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chainfo_0001.png"
      },
      {
        "label": "属性：火焰",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0001.png"
      },
      {
        "label": "定位：攻击",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0008.png"
      }
    ]
  },
  {
    "id": "4301",
    "gameId": "arcanatactics",
    "name": "诡术师",
    "subtitle": "",
    "latin": "",
    "head": "https://wiki-obs.obs.cn-north-1.myhuaweicloud.com/wiki/arcanatactics/catalog/images/001b95376efca12d6e2921613c6ac1b8a4eecb51782cf31a060bd1c1e49d0f4a.png",
    "facets": {
      "attribute": "黑暗",
      "category": "盗贼",
      "role": "辅助",
      "stars": "4"
    },
    "updatedAt": "2026-09-03",
    "traitIcons": [
      {
        "label": "职业：盗贼",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chainfo_0003.png"
      },
      {
        "label": "属性：黑暗",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0005.png"
      },
      {
        "label": "定位：辅助",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0009.png"
      }
    ]
  },
  {
    "id": "5303",
    "gameId": "arcanatactics",
    "name": "德比希",
    "subtitle": "",
    "latin": "",
    "head": "https://wiki-obs.obs.cn-north-1.myhuaweicloud.com/wiki/arcanatactics/catalog/images/99ce7aa69cc3affc699eff736b9d1b180ae30ea955a7e069fae34695035fd68e.png",
    "facets": {
      "attribute": "黑暗",
      "category": "盗贼",
      "role": "攻击",
      "stars": "5"
    },
    "updatedAt": "2026-09-03",
    "traitIcons": [
      {
        "label": "职业：盗贼",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chainfo_0003.png"
      },
      {
        "label": "属性：黑暗",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0005.png"
      },
      {
        "label": "定位：攻击",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0008.png"
      }
    ]
  },
  {
    "id": "5807",
    "gameId": "arcanatactics",
    "name": "克罗米",
    "subtitle": "",
    "latin": "",
    "head": "https://wiki-obs.obs.cn-north-1.myhuaweicloud.com/wiki/arcanatactics/catalog/images/e3f096e92f0a54e4ad80fbdf24c1388f39706ceab925e687c5203c12f028f853.png",
    "facets": {
      "attribute": "光辉",
      "category": "精灵",
      "role": "辅助",
      "stars": "5"
    },
    "updatedAt": "2026-09-03",
    "traitIcons": [
      {
        "label": "职业：精灵",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chainfo_0008.png"
      },
      {
        "label": "属性：光辉",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0004.png"
      },
      {
        "label": "定位：辅助",
        "src": "/assets/arcanatactics-source/arcanatactics_hero_icons/common_chatrait_0009.png"
      }
    ]
  },
  {
    "id": "ms_chrome",
    "gameId": "guardian-tales",
    "name": "No.9克罗姆小姐",
    "subtitle": "水库蟒蛇第九领导人",
    "latin": "Ms. Chrome",
    "head": "/assets/guardian-tales/portraits/ms_chrome.png",
    "facets": {
      "attribute": "无",
      "role": "输出",
      "stars": "4"
    },
    "traitIcons": [
      {
        "label": "属性：无",
        "src": "/assets/guardian-tales/attributes/ic_attribute_no.png"
      },
      {
        "label": "定位：输出",
        "src": "/assets/guardian-tales/roles/ic_atk_type_warrior.png"
      }
    ]
  },
  {
    "id": "2",
    "gameId": "lostsword",
    "name": "帕西瓦尔",
    "subtitle": "骑士 · 寒冰",
    "latin": "Pc_Percival_01",
    "head": "/assets/lostsword-source/portraits/Pc_Percival_01.png",
    "facets": {
      "element": "寒冰",
      "job": "骑士",
      "position": "前排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：骑士",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：寒冰",
        "src": "/assets/lostsword-source/role-icons/6aa96251a5f178f8.png"
      },
      {
        "label": "站位：前排",
        "src": "/assets/lostsword-source/role-icons/d56842ac8b55fb56.png"
      }
    ]
  },
  {
    "id": "10",
    "gameId": "lostsword",
    "name": "兰斯洛特",
    "subtitle": "骑士 · 光明",
    "latin": "Pc_Lancelot_01",
    "head": "/assets/lostsword-source/portraits/Pc_Lancelot_01.png",
    "facets": {
      "element": "光明",
      "job": "骑士",
      "position": "前排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：骑士",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：光明",
        "src": "/assets/lostsword-source/role-icons/4a79fa00abd8217a.png"
      },
      {
        "label": "站位：前排",
        "src": "/assets/lostsword-source/role-icons/d56842ac8b55fb56.png"
      }
    ]
  },
  {
    "id": "12",
    "gameId": "lostsword",
    "name": "伊丽莎白",
    "subtitle": "骑士 · 火焰",
    "latin": "Pc_Elizabeth_01",
    "head": "/assets/lostsword-source/portraits/Pc_Elizabeth_01.png",
    "facets": {
      "element": "火焰",
      "job": "骑士",
      "position": "前排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：骑士",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：火焰",
        "src": "/assets/lostsword-source/role-icons/ecd2b925ab60acca.png"
      },
      {
        "label": "站位：前排",
        "src": "/assets/lostsword-source/role-icons/d56842ac8b55fb56.png"
      }
    ]
  },
  {
    "id": "15",
    "gameId": "lostsword",
    "name": "圣女贞德",
    "subtitle": "射手 · 雷电",
    "latin": "Pc_Jan_01",
    "head": "/assets/lostsword-source/portraits/Pc_Jan_01.png",
    "facets": {
      "element": "雷电",
      "job": "射手",
      "position": "后排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：射手",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：雷电",
        "src": "/assets/lostsword-source/role-icons/c9d2cbf30e1da2b8.png"
      },
      {
        "label": "站位：后排",
        "src": "/assets/lostsword-source/role-icons/4f050a23f5591ba6.png"
      }
    ]
  },
  {
    "id": "16",
    "gameId": "lostsword",
    "name": "特里斯坦",
    "subtitle": "射手 · 自然",
    "latin": "Pc_Tristan_01",
    "head": "/assets/lostsword-source/portraits/Pc_Tristan_01.png",
    "facets": {
      "element": "自然",
      "job": "射手",
      "position": "后排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：射手",
        "src": "/assets/lostsword-source/role-icons/002ccaed67d98ec1.png"
      },
      {
        "label": "元素：自然",
        "src": "/assets/lostsword-source/role-icons/2d8e5b95d1ab8d6f.png"
      },
      {
        "label": "站位：后排",
        "src": "/assets/lostsword-source/role-icons/1113497c392556e4.png"
      }
    ]
  },
  {
    "id": "18",
    "gameId": "lostsword",
    "name": "瑟茜",
    "subtitle": "法师 · 混沌",
    "latin": "Pc_Kirke_01",
    "head": "/assets/lostsword-source/portraits/Pc_Kirke_01.png",
    "facets": {
      "element": "混沌",
      "job": "法师",
      "position": "后排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：法师",
        "src": "/assets/lostsword-source/role-icons/f973b21166594c3e.png"
      },
      {
        "label": "元素：混沌",
        "src": "/assets/lostsword-source/role-icons/966f2bd731866bf9.png"
      },
      {
        "label": "站位：后排",
        "src": "/assets/lostsword-source/role-icons/5162844642a46e91.png"
      }
    ]
  },
  {
    "id": "23",
    "gameId": "lostsword",
    "name": "加文",
    "subtitle": "骑士 · 自然",
    "latin": "Pc_Gawain_01",
    "head": "/assets/lostsword-source/portraits/Pc_Gawain_01.png",
    "facets": {
      "element": "自然",
      "job": "骑士",
      "position": "前排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：骑士",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：自然",
        "src": "/assets/lostsword-source/role-icons/fee37cacd1eca7d3.png"
      },
      {
        "label": "站位：前排",
        "src": "/assets/lostsword-source/role-icons/d56842ac8b55fb56.png"
      }
    ]
  },
  {
    "id": "32",
    "gameId": "lostsword",
    "name": "莫甘娜",
    "subtitle": "法师 · 混沌",
    "latin": "Pc_Morgana_01",
    "head": "/assets/lostsword-source/portraits/Pc_Morgana_01.png",
    "facets": {
      "element": "混沌",
      "job": "法师",
      "position": "后排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：法师",
        "src": "/assets/lostsword-source/role-icons/d04776cd2b1386dc.png"
      },
      {
        "label": "元素：混沌",
        "src": "/assets/lostsword-source/role-icons/dd515f50e37c24a1.png"
      },
      {
        "label": "站位：后排",
        "src": "/assets/lostsword-source/role-icons/515ca42b28604bca.png"
      }
    ]
  },
  {
    "id": "33",
    "gameId": "lostsword",
    "name": "桂妮维亚",
    "subtitle": "灵医 · 冰冻",
    "latin": "Pc_Guinevere_01",
    "head": "/assets/lostsword-source/portraits/Pc_Guinevere_01.png",
    "facets": {
      "element": "冰冻",
      "job": "灵医",
      "position": "后排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：灵医",
        "src": "/assets/lostsword-source/role-icons/93a1d08f3686e30f.png"
      },
      {
        "label": "元素：冰冻",
        "src": "/assets/lostsword-source/role-icons/362a69a0daa3bb27.png"
      },
      {
        "label": "站位：后排",
        "src": "/assets/lostsword-source/role-icons/f26c048bd7944834.png"
      }
    ]
  },
  {
    "id": "9",
    "gameId": "lostsword",
    "name": "鲁亚",
    "subtitle": "骑士 · 雷电",
    "latin": "Pc_Lua_01",
    "head": "/assets/lostsword-source/portraits/Pc_Lua_01.png",
    "facets": {
      "element": "雷电",
      "job": "骑士",
      "position": "前排",
      "stars": "5"
    },
    "updatedAt": "2026-09-17",
    "traitIcons": [
      {
        "label": "职业：骑士",
        "src": "/assets/lostsword-source/role-icons/7ac9b94bf9973d09.png"
      },
      {
        "label": "元素：雷电",
        "src": "/assets/lostsword-source/role-icons/b8df58d3ae95382a.png"
      },
      {
        "label": "站位：前排",
        "src": "/assets/lostsword-source/role-icons/d56842ac8b55fb56.png"
      }
    ]
  }
];
export const heroUrl = (hero: { gameId: string; id: string }) => `/heroes/${hero.gameId}/${hero.id}`;
